export type DeepReadonly<T> = {
  readonly [P in keyof T]: DeepReadonly<T[P]>;
};

export function copyData<T>(data: T): T {
  return JSON.parse(JSON.stringify(data));
}
